var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "setting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.852,
    height: 63.979,
    viewBox: "0 0 63.852 63.979",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setting-2",
    "data-name": "Setting",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22340",
    "data-name": "Path 22340",
    d: "M59.174,0H5.694A5.191,5.191,0,0,0,.508,5.186V58.793a5.191,5.191,0,0,0,5.186,5.186H59.174a5.191,5.191,0,0,0,5.186-5.186V5.186A5.191,5.191,0,0,0,59.174,0ZM5.694,2.749H59.174a2.439,2.439,0,0,1,2.436,2.436V15.244H3.257V5.186A2.439,2.439,0,0,1,5.694,2.749Zm53.481,58.48H5.694a2.439,2.439,0,0,1-2.436-2.436v-40.8H61.611v40.8A2.439,2.439,0,0,1,59.174,61.229Z",
    transform: "translate(-0.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22341",
    "data-name": "Path 22341",
    d: "M268.859,63.745H245.867a1.375,1.375,0,1,1,0-2.749h22.993a1.375,1.375,0,1,1,0,2.749Z",
    transform: "translate(-214.004 -53.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22342",
    "data-name": "Path 22342",
    d: "M143.886,217.241h-7.622a1.375,1.375,0,0,1-1.375-1.375v-3.582a12.676,12.676,0,0,1-2.317-1.343l-3.107,1.794a1.375,1.375,0,0,1-1.878-.5l-3.811-6.6a1.374,1.374,0,0,1,.5-1.878l3.071-1.773a11.026,11.026,0,0,1,0-2.716l-3.071-1.773a1.375,1.375,0,0,1-.5-1.878l3.811-6.6a1.375,1.375,0,0,1,1.878-.5l3.107,1.794a12.685,12.685,0,0,1,2.317-1.343v-3.582A1.375,1.375,0,0,1,136.264,184h7.622a1.375,1.375,0,0,1,1.375,1.375v3.582a12.676,12.676,0,0,1,2.317,1.343l3.107-1.794a1.375,1.375,0,0,1,1.878.5l3.811,6.6a1.374,1.374,0,0,1-.5,1.878l-3.071,1.773a11.026,11.026,0,0,1,0,2.716l3.071,1.773a1.375,1.375,0,0,1,.5,1.878l-3.811,6.6a1.375,1.375,0,0,1-1.878.5l-3.107-1.794a12.684,12.684,0,0,1-2.317,1.343v3.582A1.375,1.375,0,0,1,143.886,217.241Zm-6.247-2.749h4.873v-3.137a1.375,1.375,0,0,1,.914-1.3,9.969,9.969,0,0,0,3.14-1.82,1.375,1.375,0,0,1,1.579-.145l2.723,1.572,2.436-4.22-2.693-1.555a1.374,1.374,0,0,1-.664-1.44,9.057,9.057,0,0,0,0-3.66,1.374,1.374,0,0,1,.664-1.44L153.3,195.8l-2.436-4.22-2.723,1.572a1.375,1.375,0,0,1-1.579-.145,9.97,9.97,0,0,0-3.14-1.82,1.375,1.375,0,0,1-.914-1.3v-3.137h-4.873v3.137a1.375,1.375,0,0,1-.914,1.3,9.97,9.97,0,0,0-3.14,1.82,1.375,1.375,0,0,1-1.579.145l-2.723-1.572-2.436,4.22,2.693,1.555a1.374,1.374,0,0,1,.664,1.44,9.055,9.055,0,0,0,0,3.66,1.374,1.374,0,0,1-.664,1.44l-2.693,1.555,2.436,4.22L132,208.1a1.375,1.375,0,0,1,1.579.145,9.972,9.972,0,0,0,3.14,1.82,1.375,1.375,0,0,1,.914,1.3Z",
    transform: "translate(-108.213 -161.011)",
    fill: "#61ce65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22343",
    "data-name": "Path 22343",
    d: "M219.179,285.869a5.186,5.186,0,1,1,5.186-5.186A5.191,5.191,0,0,1,219.179,285.869Zm0-7.622a2.436,2.436,0,1,0,2.436,2.436A2.439,2.439,0,0,0,219.179,278.247Z",
    transform: "translate(-187.317 -241.072)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22344",
    "data-name": "Path 22344",
    d: "M186.107,64.752a1.371,1.371,0,1,1,.269-2.722A1.371,1.371,0,0,1,186.107,64.752Z",
    transform: "translate(-161.74 -54.255)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22345",
    "data-name": "Path 22345",
    d: "M127.146,64.752a1.371,1.371,0,1,1,.269-2.722A1.371,1.371,0,0,1,127.146,64.752Z",
    transform: "translate(-110.147 -54.254)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22346",
    "data-name": "Path 22346",
    d: "M69.2,64.753a1.371,1.371,0,1,1,.269-2.722A1.371,1.371,0,0,1,69.2,64.753Z",
    transform: "translate(-59.441 -54.255)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.0ef26e4de9fbfbd88eef210ce2bd231c.svg";
export { ForwardRef as ReactComponent };